export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/ee9346a7a9322dc42520ebdf49402b79.svg";